import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router';
import store from './store'
import Constantes from "./store/constantes.js";
import { routes } from './router/routes';
import { routesRentas } from './router/routesRentas'
import { routesEstadoCuenta } from './router/routesEstadoCuenta'
import { routesMultasAdministrativas } from './router/routesMultasAdministrativas'

import VueSweetalert2 from 'vue-sweetalert2';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker';
require('./helpers/Auth');
require('./helpers/jwt.interceptor');

import Multiselect from 'vue-multiselect'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'bootstrap';
import './assets/app.css';
import './assets/css/main.scss';
import 'vue-search-select/dist/VueSearchSelect.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import LoadScript from 'vue-plugin-load-script';
import { VueReCaptcha } from "vue-recaptcha-v3";
import locale from 'element-ui/lib/locale/lang/es'


Vue.use(ElementUI, { locale })
Vue.use(VueReCaptcha, { siteKey: "6LdwTt4ZAAAAAGNFxT8_DVJCor3-tCcWV2R7MUpu" });

Vue.use(LoadScript);
Vue.use('multiselect', Multiselect);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false
Vue.use(VueSweetalert2);
Vue.use(VueRouter);
Vue.use(Datepicker);
Vue.use(ElementUI, { locale })
Vue.directive('uppercase', {
    update(el) {
        el.value = el.value.toUpperCase()
    },
})

const allRoutes = Array.prototype.concat(
    routes,
    routesRentas,
    // routesReservaCanchas,
    routesEstadoCuenta,
    routesMultasAdministrativas
);

const router = new VueRouter({
    routes: allRoutes,
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    mode: 'hash'
        // mode: 'history'
});

// Validación Login por Router
const rutasPermitidas = {

    plataforma: true,
    pageRecupera: true,
    pageregistroUsuario: true,
    perfil: true,
    pageregistroUsuarioOption: true,
    pageLogin: true,
    pageContrasenia: true,
    // pageCasillaElectronica: true,
    pageRecuperaContrasenia: true,
    pageBuscaCorreo: true,
    pageBuscaCorreoValido: true,
    pageBuscaCorreoInvalido: true,
    pageRecuperaContraseniaproceso: true,
    pageConsultaProcedimiento: true,
    pageRegistroDireccion: true,
    pageSolicitudInfPublica: true,
    pageMultasAdministrativas: true,
    pageMultasAdministrativasEstadoCuenta: true,
    consultaCuponera: true,
    pageSolicitudReclamaciones: true,
    descargaEstadoCuenta: true,
    descargaCuponera: true,
    consultaTramiteDocumentario: true,
    pagecontribuyentesParametros: true,
    pagecontribuyentes: true,
    pageValidacionLogin: true,
    MenuCanchaTenisApp:true,
    ConsultaCancha:true,
    ReservaCancha:true,
    ReservaCancelada:true,
    pagereeditarusuario:true,
    pagosOnline:true,
    cartaTramitevisa:true,
    cartaTramite:true,
    // pageestadocuenta:true,
    // pageeccontribuyente:true,
    // pageecreporte:true,
    pageRegistroEleccionesVecinales:true,
}

const paginasPermitidas = [
    'pagecontribuyentes',
    'pagecontribuyentesParametros',
    'plataforma',
    'perfil',
    'pageregistroUsuarioOption',
    'pageregistroUsuario',
    'pageConsultaProcedimiento',
    'pageSolicitudInfPublica',
    'pageMultasAdministrativas',
    'pageMultasAdministrativasEstadoCuenta',
    'consultaCuponera',
    'pageSolicitudReclamaciones',
    'descargaEstadoCuenta',
    'descargaCuponera',
    'consultaTramiteDocumentario',
    'pageValidacionLogin',
    'MenuCanchaTenisApp',
    'ConsultaCancha',
    'ReservaCancha',
    'ReservaCancelada',
    'pagereeditarusuario',
    'pagosOnline',
    'cartaTramitevisa',
    'cartaTramite',
    // 'pageestadocuenta',
    // 'pageeccontribuyente',
    // 'pageecreporte',
    'pageRegistroEleccionesVecinales',
];

router.beforeEach((to, from, next) => {
    console.log(to)

    if(Constantes.mantenimiento){
        localStorage.clear();
    }
    if (!rutasPermitidas[to.name]) {
        window.rutaReturn = to.path
    }
    if (!Vue.prototype.$userLogged && rutasPermitidas[to.name]) {
        next()
    } else if (Vue.prototype.$userLogged && (rutasPermitidas[to.name] && !paginasPermitidas.includes(to.name))) {
        next('/')
    } else if (Vue.prototype.$userLogged) {
        if (!to.name) {
            next('/')
        } else {
            next()
        }
    } else {
        window.rutaReturn =''
        next('/login')   
    }
})

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js